import React from "react";
import LandingPage from "components/LandingPage";
import { PublicRoute } from "components/Auth";

export default function Home() {
    return (
        <PublicRoute>
            <LandingPage />
        </PublicRoute>
    );
}
